import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthService from '../../API/AuthService';
import useUserStore from '../../store/userStore';
import cl from './Register.module.css';
import { IconArrowRight } from '../../components/icons';
import usePageMeta from '../../hooks/usePageMeta';
import YandexLoginButton from '../../components/OAuth/YandexLoginButton';
import GoogleMigrationModal from '../../components/OAuth/GoogleMigrationModal';

// Вход для уже зарегистрированных центров (b2b_lead и b2b_owner).
// Использует тот же user-микросервис, что и Майнкрафтия — единый login.
// Также доступен OAuth-вход через Яндекс / Google (создаст обычный профиль,
// для работы с центром потом нужно будет зарегистрировать центр в кабинете).
export default function Login() {
    usePageMeta({
        title: 'Вход · СтартКласс',
        description: 'Вход в кабинет руководителя детского центра.',
    });
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState('');
    const [loading, setLoading] = useState(false);
    const [showGoogleHelp, setShowGoogleHelp] = useState(false);
    const navigate = useNavigate();
    const refresh = useUserStore(s => s.refresh);

    async function onSubmit(e) {
        e.preventDefault();
        setErr('');
        setLoading(true);
        const res = await AuthService.login(email.trim().toLowerCase(), password);
        if (res.ok) {
            await refresh();
            navigate('/cabinet');
        } else {
            setErr(res.message || 'Не удалось войти. Проверьте e-mail и пароль.');
        }
        setLoading(false);
    }

    return (
        <main className={cl.page}>
            <form className={cl.card} onSubmit={onSubmit}>
                <div className={cl.head}>
                    <span className={cl.eyebrow}>Вход</span>
                    <h1 className={cl.title}>С возвращением</h1>
                    <p className={cl.lead}>Войдите, чтобы открыть кабинет вашего центра</p>
                </div>

                {err && <div className={cl.err}>{err}</div>}

                {/* OAuth-вход. Кнопки делают тот же login, что и email/пароль —
                    создают или восстанавливают сессию через user-микросервис. */}
                <div style={{ marginBottom: 16 }}>
                    <YandexLoginButton disabled={loading} />
                    {/* Вход через Google убран: с 07.07.2026 иностранный OAuth
                        на российских сайтах запрещён (149-ФЗ). Вместо кнопки —
                        плашка с инструкцией по восстановлению доступа по паролю. */}
                    <button
                        type="button"
                        onClick={() => setShowGoogleHelp(true)}
                        style={{
                            width: '100%',
                            marginTop: 10,
                            padding: '11px 14px',
                            borderRadius: 12,
                            border: '1px solid #e2e8f0',
                            background: '#f8fafc',
                            color: '#475569',
                            fontSize: 13.5,
                            fontWeight: 600,
                            fontFamily: 'inherit',
                            cursor: 'pointer',
                            textAlign: 'center',
                        }}
                    >
                        Раньше входили через Google?
                    </button>
                    <div style={{
                        textAlign: 'center',
                        margin: '14px 0 4px',
                        color: '#94a3b8',
                        fontSize: 13,
                        position: 'relative',
                    }}>
                        <span style={{ background: '#fff', padding: '0 12px', position: 'relative', zIndex: 1 }}>
                            или войти по e-mail
                        </span>
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: 0, right: 0,
                            height: 1,
                            background: '#e6e7eb',
                            zIndex: 0,
                        }} />
                    </div>
                </div>

                <div className={cl.field}>
                    <label htmlFor="email">E-mail</label>
                    <input id="email" type="email" required value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="you@example.com"/>
                </div>
                <div className={cl.field}>
                    <label htmlFor="password">Пароль</label>
                    <input id="password" type="password" required value={password}
                        onChange={e => setPassword(e.target.value)}
                        placeholder="••••••••"/>
                </div>

                <div className={cl.actions}>
                    <button type="submit" className={cl.btnPrimary} disabled={loading}>
                        {loading ? 'Входим…' : (<>Войти <IconArrowRight width={16} height={16}/></>)}
                    </button>
                </div>

                <div className={cl.altLink}>
                    Нет аккаунта? <Link to="/registration">Зарегистрировать центр</Link>
                </div>
            </form>

            {showGoogleHelp && (
                <GoogleMigrationModal onClose={() => setShowGoogleHelp(false)} />
            )}
        </main>
    );
}
